import { AppMode, AppState, RecordingState } from "@core/context/types";
import appEvents from "@core/events/events";

let currentMode: AppMode | undefined = undefined;
let currentState: AppState | undefined = undefined;
let currentRecordingState: RecordingState = RecordingState.NONE;

const setCurrentMode = (mode: AppMode): void => {
  currentMode = mode;
};

export const getCurrentMode = (): AppMode | undefined => {
  return currentMode;
};

const setCurrentState = (state: AppState): void => {
  currentState = state;
};

export const getCurrentState = (): AppState | undefined => {
  return currentState;
};

const setCurrentRecordingState = (state: RecordingState): void => {
  currentRecordingState = state;
};

export const getCurrentRecordingState = (): RecordingState => {
  return currentRecordingState;
};

// Subscribe to app events to keep global state in sync
appEvents.on('app-state-changed', (state: AppState) => {
  setCurrentState(state);
});

appEvents.on('app-mode-changed', (mode: AppMode) => {
  setCurrentMode(mode);
});

export const __internal = {
  setCurrentMode,
  setCurrentState,
  setCurrentRecordingState,
};

